'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { createContext, use } from 'react';
import type { PageResponseItemDto } from '@sola/schema/lib/contentful.ts';
export type PositionedContentMap = Record<string, PageResponseItemDto | null>;
const PositionedContentContext = createContext<PositionedContentMap | null>(null);
export const PositionedContentProvider = t0 => {
  const $ = _c(3);
  const {
    children,
    content
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== content) {
    t1 = <PositionedContentContext value={content}>{children}</PositionedContentContext>;
    $[0] = children;
    $[1] = content;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const usePositionedContent = (position: string) => {
  const content = use(PositionedContentContext);
  return content?.[position] ?? null;
};